export default __webpack_public_path__ + "static/media/NQPHN-commissioned-services-map-icons_Chronic Conditions.8deb543f.png";